module.exports = __webpack_public_path__ + "img/20190530160726911.1e08d482.png";